import React from "react";
import { useHistory, useParams } from "react-router-dom";

import { Context, fetchActiveLearningLesson } from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import ActiveLearningProjection from "../../../templates/teacher/ActiveLearningProjection";

export default () => {
  const lessonParam = parseInt(parseQueryParams()["lesson"]);
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const { id } = useParams();

  // if (lessonParam) {
  //   history.push(notFoundPath);
  //   return null;
  // }

  React.useEffect(() => {
    dispatch(fetchActiveLearningLesson(lessonParam, id));
  }, [dispatch, lessonParam, id]);

  const lesson = React.useMemo(
    () =>
      state.activeLearningLesson &&
      state.activeLearningLesson.id === lessonParam
        ? state.activeLearningLesson
        : null,
    [lessonParam, state.activeLearningLesson],
  );

  const handleChangeLesson = React.useCallback(
    lessonId => {
      history.push({
        search: `?lesson=${lessonId}`,
      });
    },
    [history],
  );

  return (
    <ActiveLearningProjection
      lesson={lesson}
      prevLessonId={state.prev_lesson_id}
      nextLessonId={state.next_lesson_id}
      onChangeLesson={handleChangeLesson}
    />
  );
};
